import { createAction } from 'redux-actions';
import { Types } from './types';

export const getUserTrustedDevicesRequest = createAction(
  Types.GET_USER_TRUSTED_DEVICES_REQUEST
);
export const getUserTrustedDevicesFulfilled = createAction(
  Types.GET_USER_TRUSTED_DEVICES_FULFILLED
);
export const getUserTrustedDevicesRejected = createAction(
  Types.GET_USER_TRUSTED_DEVICES_REJECTED
);

export const deleteTrustedDeviceRequest = createAction(
  Types.DELETE_TRUSTED_DEVICE_REQUEST
);
export const deleteTrustedDeviceFulfilled = createAction(
  Types.DELETE_TRUSTED_DEVICE_FULFILLED
);
export const deleteTrustedDeviceRejected = createAction(
  Types.DELETE_TRUSTED_DEVICE_REJECTED
);
